const Arrow2 = (props: React.SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8 10" {...props}>
		<path
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={2}
			d="M4 8.5v-7m0 7-3-3m3 3 3-3"
		/>
	</svg>
);
export default Arrow2;
